<template>
  <Breadcrumb></Breadcrumb>
  <SaleListingAgreementForm :saleListingAgreement="saleListingAgreement" :title="$gettext('Editer une mission de vente')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import { useSaleListingAgreementStore } from "@/stores/saleListingAgreement";
import { useRouter, useRoute } from "vue-router";
import SaleListingAgreementForm from "@/components/sale-listing-agreements/SaleListingAgreementForm.vue";
import { ref, onMounted } from "vue";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";


const router = useRouter();
const route = useRoute();
const saleListingAgreementStore = useSaleListingAgreementStore();
const saleListingAgreement = ref(null);
const saleListingAgreementId = route.params.id;

const onSubmit = (payload, actions) => {
  saleListingAgreementStore.save(payload, () => {
    router.push({ name: "sale-listing-agreement", params: { id: saleListingAgreementId } });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

onMounted(async () => {
  saleListingAgreement.value = await saleListingAgreementStore.fetchOne(saleListingAgreementId);
});

</script>
